import { render } from "./corporate-resources.vue?vue&type=template&id=ffab6f92"
import script from "./corporate-resources.vue?vue&type=script&lang=js"
export * from "./corporate-resources.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__